import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';

@Injectable()
export class InstallationGroundLevelPluginService extends InspectionPluginService {
  private levelTypesKeys = [
    { value: 1, label: 'plugins.installationgroundlevel.flat' },
    { value: 2, label: 'plugins.installationgroundlevel.ramp' },
    { value: 3, label: 'plugins.installationgroundlevel.step' }
  ];

  private levelTypes = [];
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  getLevelTypes() {
    return this.levelTypes;
  }

  public updateGroundLevel(inspectionId: string, pointId: string, pluginId: string, levelType: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, levelType).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private applyTranslations() {
    this.levelTypes = [];
    this.copyTranslationValues(this.levelTypesKeys, this.levelTypes, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, levelType: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, levelType).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
